<template>
  <div ref="mapRef" class="mainBox">
    <!-- 使用 vue-baidu-map-3x 提供的 BaiduMap 组件 -->
    <nyTit  pathUrl='/plantmoxing' />
    <div class="container">
      <!-- 第一部分开始 -->
      <div class="qu_kuai_1 qu_kuai">
        <!-- 第一个标题开始 -->
        <div class="t_bt">
          <h5>项目总概况</h5>
          <span></span>
          <span class="gs"></span>
        </div>
        <!-- 第一个标题下的内容 -->
        <div class="gai_kuang">
          <div
            class="gai_kuang_nr"
            v-for="(item, index) in gkdata"
            :key="index"
          >
            <div class="gai_kuang_nr_jz">
              <img :src="item.img" />
              <div class="mian_j">
                <h5>{{ item.value }}</h5>
                <h6>{{ item.name }}</h6>
              </div>
              <span>{{ item.dw }}</span>
            </div>
          </div>
        </div>
        <!-- 第二个标题开始 -->
        <div class="t_bt">
          <h5>效益分析</h5>
          <span></span>
          <span class="gs"></span>
        </div>
        <!-- 第二个标题内容开始 -->
        <div class="di2_bt_nr"><LeftBar /></div>
        <!-- 第二个标题内容1开始 -->
        <div class="di2_bt_nr1">
          <div class="di2_bt_nr1_bt">项目进度</div>

          <div
            class="di2_bt_nr1_nr"
            v-for="(item, index) in xmjddata"
            :key="index"
          >
            <div class="di2_bt_nr1_nr_bg">
              <img :src="item.jd" />
            </div>
            <div class="di2_bt_nr1_nr_jt">
              <img :src="item.img" />
            </div>
          </div>
          <div class="di2_bt_nr1_nr">
            <div class="di2_bt_nr1_nr_bg">
              <img :src="xmjddatalast" />
            </div>
          </div>
        </div>
        <!-- 第二个标题内容2开始 -->
        <div class="di2_bt_nr2">
          <dv-percent-pond
            :config="config"
            style="width: 100%; height: 100%; font-size: 13px !important"
          />
        </div>
      </div>
      <!-- 第二块内容 -->
      <div class="qu_kuai_2 qu_kuai">
        <div class="qu_kuai_2_top">
<!--          <vue3VideoPlay-->
<!--            width="100%"-->
<!--            height="100%"-->
<!--            :src="options1.src"-->
<!--            :type="options1.type"-->
<!--            :poster="options1.poster"-->
<!--            :autoPlay="false"-->
<!--            :control="false"-->
<!--            :controlBtns="false"-->
<!--          />-->
          <!-- <img src="../assets/img/gbyunying/tp.png" /> -->
          <div style=" width: 100%;height: 100%" v-if="AccessToken!=''">
            <iframe
              :src="options1.src+AccessToken"
              width="100%"
              height="100%"
              id="ysOpenDevice"
              allowfullscreen
            >
            </iframe>
          </div>
        </div>
        <div class="qu_kuai_2_down"><nyNav /></div>
      </div>
      <div class="qu_kuai_3 qu_kuai">
        <div class="t_bts">
          <h5>运营视频巡检</h5>
          <span></span>
          <span class="gs"></span>
        </div>
        <div class="yunying_sp" @click="videoClick(0)">
          <img src="https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/7.png" />
        </div>
        <div class="t_bts">
          <h5>灌溉方式及面积</h5>
          <span></span>
          <span class="gs"></span>
        </div>
        <div class="guangai_mj">
          <div class="guangai_mj_left">
            <div
              class="guangai_type"
              v-for="(item, index) in guangdata"
              :key="index"
            >
              {{ item.name }}
            </div>
          </div>
          <div class="guangai_mj_left">
            <Rigsbq />
          </div>
        </div>
      </div>
      <div class="qu_kuai_4 qu_kuai">
        <div class="t_bts">
          <h5>项目投资概况</h5>
          <span></span>
          <span class="gs"></span>
        </div>
        <div class="xiangmu_gk">
          <div class="xiangmu_gk_top">{{ xmgk_txt }}</div>
          <div class="xiangmu_gk_down">
            <RightBar />
          </div>
        </div>

        <div class="t_bts">
          <h5>整体项目流程</h5>
          <span></span>
          <span class="gs"></span>
        </div>
        <div class="xiangmu_lc">
          <div class="yunying_sp" @click="videoClick(1)">
            <img src="../assets/img/gbzntjsyzt/1.jpg" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 弹出视频 -->
  <popBg
    :title="videoList[curVideoIndex].name"
    style="z-index: 99999"
    :popShow="popShow"
    @hiddlen="popHiddlen"
  >
<!--    <vue3VideoPlay-->
<!--      id="video"-->
<!--      width="100%"-->
<!--      height="100%"-->
<!--      title="冰河世纪"-->
<!--      :src="videoList[curVideoIndex].options.src"-->
<!--      :type="videoList[curVideoIndex].options.type"-->
<!--      :autoPlay="true"-->
<!--    />-->
    <div style="width: 100%;height: 100%;" v-if="AccessToken!=''"><iframe :src="videoList[curVideoIndex].options.src+AccessToken" width="100%" height="100%" id="ysOpenDevice" allowfullscreen></iframe></div>

  </popBg>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { useRouter } from "vue-router";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
} from "vue";

// todo 项目使用请放开 leaflet 引入

// import * as L from 'leaflet/dist/leaflet.esm.js';
import nyNav from "../components/nyNav.vue";
import nyTit from "../components/nyTit.vue";
import popBg from "../components/popBg.vue";
import LeftBar from "../components/gbyunying/LeftBar";
import Rigsbq from "../components/gbyunying/rigsbq";
import RightBar from "../components/gbyunying/rightBar";
import { useStore } from "vuex";
export default {
  name: "Home",
  setup() {
    // const timer = ref(null);
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      config: {
        // lineDash
        colors: ["#05252A", "#45F4C9"],
        value: 50,
        borderWidth: 5,

        borderRadius: 5,
        borderGap: 20,
        lineDash: [220, 16],
      },
      // options1: {
      //   src: require("@/assets/video/jindu.mp4"), //视频源
      //   type: "video/mp4", //视频类型
      //   poster: require("@/assets/img/gbyunying/tp.png"),
      // },
      options1: {
        src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/J57579282/1.live&autoplay=1&accessToken=", //视频源
        type: "m3u8", //视频类型

      },
      videoList: [
        {
          name: "运营视频巡检",
          // options: {
          //   src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/7.mp4", //视频源
          //   type: "video/mp4", //视频类型
          // },
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/J57579282/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          }
        },
        {
          name: "高标准农田2",
          // options: {
          //   src: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/nysp/7.mp4", //视频源
          //   type: "video/mp4", //视频类型
          // },
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538489/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          }
        },
      ],
      gkdata: [
        {
          name: "项目总面积",
          dw: "亩",
          value: "50000.00",
          img: require("@/assets/img/gbyunying/td.png"),
        },
        {
          name: "已建成面积",
          dw: "亩",
          value: "15000.00",
          img: require("@/assets/img/gbyunying/yd.png"),
        },
        {
          name: "种植面积",
          dw: "亩",
          value: "15000.00",
          img: require("@/assets/img/gbyunying/zz.png"),
        },
        {
          name: "核心区域",
          dw: "亩",
          value: "15000.00",
          img: require("@/assets/img/gbyunying/ys.png"),
        },
      ],
      xmjddata: [
        {
          img: require("@/assets/img/gbyunying/jt.png"),
          jd: require("@/assets/img/gbzntjsyzt/1.jpg"),
        },
        {
          img: require("@/assets/img/gbyunying/jt.png"),
          jd: require("@/assets/img/gbzntjsyzt/2.jpg"),
        },
        {
          img: require("@/assets/img/gbyunying/jt.png"),
          jd: require("@/assets/img/gbzntjsyzt/3.jpg"),
        },
      ],
      xmjddatalast: require("@/assets/img/gbzntjsyzt/4.jpg"),
      curVideoIndex: 0,
      popShow: false,
      AccessToken:"",

      leftData1Cur: 0,

      curLeftIndex: 0,

      faSHow: false,
      xmgk_txt:
        "上蔡县5万亩高标准农田示范区项目，建设面积5万亩，计划投资1.5亿元。现在建成的为第一期工程1.5万亩核心区，总投资4837万元。",
      guangdata: [
        {
          name: "固定式喷灌(300亩)",
        },
        {
          name: "半固定式喷灌(2600亩)",
        },
        {
          name: "平移式喷灌(250亩)",
        },
        {
          name: "绞盘式喷灌(9000亩)",
        },
        {
          name: "微灌式喷灌(3000亩)",
        },
      ],
    });

    // 在 onMounted 中初始化地图
    onMounted(() => {

      store.commit('getToken')
      setTimeout(()=>{
        console.log(store.state.AccessToken)
        state.AccessToken = store.state.AccessToken
      },1000)

    });

    // 返回上一页
    function clickReturn() {
      router.go(-1);
    }

    // 弹出视频
    function videoClick(index) {
      console.log(index);
      state.popShow = true;
      state.curVideoIndex = index;
    }
    // 关闭弹出
    function popHiddlen() {
      state.popShow = false;
    }

    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });

    return {
      ...toRefs(state),

      clickReturn,
      videoClick,
      popHiddlen,
    };
  },
  components: {
    nyNav,
    nyTit,
    LeftBar,
    popBg,
    Rigsbq,
    RightBar,
  },
};
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
::v-deep .dv-percent-pond text {
  font-size: 36px;
}

::v-deep .d-player-wrap .d-player-control {
  height: 30px;
}
::v-deep .d-player-wrap,
::v-deep .d-player-wrap {
  object-fit: cover;
  // background-color: #ff0000 !important;
  background-color: transparent !important; /* 设置背景色为透明 */
}
.mainBox {
  width: 100%;
  height: 100%;
  background: url("../assets/img/gbyunying/bg.png") no-repeat top center;
  background-size: 100% 100%;
  .container {
    width: 100%;
    height: calc(100% - 173px);
    display: flex;
    // 左边公共标题
    .t_bt {
      width: 100%;
      height: 120px;
      position: relative;
      left: 0;
      h5 {
        width: 100%;
        height: 100%;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 800;
        font-size: 40px;
        color: #ffefd4;
        line-height: 71px;
        text-shadow: 3px 0px 13px #000000;
        text-align: center;
        font-style: normal;
        text-transform: none;
        background: radial-gradient(0deg, #fffbf2 60%, #f8da9b 100%);
      }
      span {
        width: 100%;
        height: 100%;
        background: url("../assets/img/plantmoxing/btk.png") no-repeat top
          center;
        background-size: 100% 100%;
        position: absolute;
        left: 0;
        line-height: 200%;
        top: 40px;
      }
      .gs {
        width: 150px;
        height: 20px;
        background: url("../assets/img/plantmoxing/gx.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        left: 46%;
        top: 58%;
        animation: left1Img 2s linear infinite;
      }
    }

    // 右边公共标题
    .t_bts {
      width: 100%;
      height: 120px;
      position: relative;
      left: 0;
      h5 {
        width: 100%;
        height: 100%;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 800;
        font-size: 40px;
        color: #ffefd4;
        line-height: 71px;
        text-shadow: 3px 0px 13px #000000;
        text-align: center;
        font-style: normal;
        text-transform: none;
        background: radial-gradient(0deg, #fffbf2 60%, #f8da9b 100%);
      }
      span {
        width: 100%;
        height: 100%;
        background: url("../assets/img/plantmoxing/btk.png") no-repeat top
          center;
        background-size: 100% 100%;
        position: absolute;
        left: 0;
        line-height: 200%;
        top: 40px;
      }
      .gs {
        width: 150px;
        height: 20px;
        background: url("../assets/img/plantmoxing/gx.png") no-repeat top center;
        background-size: 100% 100%;
        position: absolute;
        left: 42.5%;
        top: 58%;
        animation: left1Img 2s linear infinite;
      }
    }

    .qu_kuai {
      // border: 1px solid #fff;
      display: flex;
      flex-direction: column;
    }
    .qu_kuai_1 {
      width: 29%;
      height: 100%;
      margin-left: 100px;
      margin-right: 50px;
      .gai_kuang {
        width: 100%;
        height: 140px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 25px;
        .gai_kuang_nr {
          width: 22%;
          height: 100%;
          display: flex;

          .gai_kuang_nr_jz {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 100px;
              height: 100px;
              margin-left: 45px;
              margin-right: 25px;
            }
            .mian_j {
              flex: 1;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: flex-start;
              line-height: 50px;
              h5 {
                font-size: 40px;
                color: #13d766;
              }
              h6 {
                font-size: 30px;
                color: #fff;
              }
            }
            span {
              color: #fff;
              font-size: 30px;
              margin-right: 15px;
            }
          }
        }
      }
      .di2_bt_nr {
        flex: 1;
      }

      .di2_bt_nr1 {
        width: 100%;
        height: 250px;
        margin: 40px 0;
        display: flex;
        justify-content: center;
        align-items: center;

        .di2_bt_nr1_bt {
          width: 50px;
          margin-left: 20px;
          color: #fff;
          font-size: 40px;
        }
        .di2_bt_nr1_nr {
          flex: 1;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          .di2_bt_nr1_nr_bg {
            width: 300px;
            height: 250px;
            background: url("../assets/img/gbyunying/tpk.png") no-repeat top
              center;
            background-size: 100% 100%;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .di2_bt_nr1_nr_jt {
            width: 128px;
            height: 36px;
            margin-left: 30px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .di2_bt_nr1_nr:last-child {
        width: 300px;
        height: 250px;
        flex: initial;
      }
      .di2_bt_nr2 {
        width: 98%;
        height: 150px;
        margin-left: 2%;
        margin-bottom: 40px;
      }
    }
    .qu_kuai_2 {
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: column;
      .qu_kuai_2_top {
        width: 100%;
        height: 1100px;
        background: url("../assets/img/gbyunying/spk.png") no-repeat top center;
        background-size: 100% 100%;
        margin-top: 50px;
        padding: 25px 60px 35px 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        // margin-bottom: 60px;
        // img {
        //   width: 100%;
        //   height: 100%;
        //   // padding: 40px 80px;
        //   padding: 50px 120px 50px 250px;
        // }
      }
      .qu_kuai_2_top:hover {
        cursor: pointer;
      }
      .qu_kuai_2_down {
        width: 100%;
        height: 250px;
        padding: 20px 65px;
        margin-bottom: 60px;
        margin-top: 20px;
      }
    }
    .qu_kuai_3 {
      width: 16%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin-left: 50px;
      .yunying_sp {
        width: 900px;
        height: 600px;
        background: url("../assets/img/gbyunying/tpk.png") no-repeat top center;
        background-size: 100% 100%;
        margin-bottom: 40px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          padding: 20px 20px;
        }
      }
      .yunying_sp:hover {
        cursor: pointer;
      }
      .guangai_mj {
        width: 100%;
        flex: 1;
        display: flex;
        .guangai_mj_left {
          width: 50%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding:5% 2%;
        }
        .guangai_type {
          width: 100%;
          flex: 1;
          background: url("../assets/img/gbyunying/wzbj.png") no-repeat top
            center;
          background-size: 100% 100%;
          color: #fff;
          font-size: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 15px 0;
        }
      }
    }
    .qu_kuai_4 {
      width: 16%;
      height: 100%;
      display: flex;
      flex-direction: column;
      margin-left: 50px;
      margin-right: 100px;
      .xiangmu_gk {
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        .xiangmu_gk_top {
          width: 100%;
          height: 200px;
          font-size: 34px;
          color: #fff;
          line-height: 50px;
          text-align: left;
          text-indent: 2em;
        }
        .xiangmu_gk_down {
          width: 100%;
          flex: 1;
          margin-top: 30px;
          margin-bottom: 20px;
        }
      }
      .xiangmu_lc {
        width: 100%;
        height: 580px;
        display: flex;
        align-items: center;
        justify-content: center;
        .yunying_sp {
          width: 840px;
          height: 560px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: url("../assets/img/gbyunying/tpk.png") no-repeat top
            center;
          background-size: 100% 100%;
          margin-bottom: 20px;
          img {
            width: 100%;
            height: 100%;
            padding: 20px 20px;
          }
        }
      }
    }
  }
}
@keyframes guangying {
  /*引用动画名称*/
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(-360deg);
  }
}
@keyframes left1Img {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.3);
  }
  100% {
    transform: scale(1);
  }
}
</style>
